import { render } from "./ThirdCut.vue?vue&type=template&id=16016978&scoped=true"
import script from "./ThirdCut.vue?vue&type=script&lang=js"
export * from "./ThirdCut.vue?vue&type=script&lang=js"

import "./ThirdCut.vue?vue&type=style&index=0&id=16016978&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16016978"]])

export default __exports__